module.exports = __webpack_public_path__ + "assets/img/Edito_Patrick-Follea_cover.5eb692af-ps.jpg";